module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_budzets-d6e04075a13f6a7c99808ec2178c82fe.png";